// ============================================================================
// BonBoZ: phần TÍNH của trang Tổng quan. Hàm thuần, không chạm DOM, có test.
//
// Tách ra file riêng vì đây là chỗ đã đẻ ra lỗi thật: trang từng hiện
// **tỷ lệ ra số 600%**. Nguyên nhân không phải lỗi chia, mà là tử số và mẫu số
// đếm HAI LỨA KHÁCH KHÁC NHAU:
//
//   - `conversations_count` đếm theo `conversations.created_at`
//     (hội thoại MỞ RA trong kỳ)
//   - `resolutions_count` đếm sự kiện `conversation_resolved` XẢY RA trong kỳ
//     (report_metric_registry.rb) — kể cả của hội thoại mở từ tháng trước
//
// Đầu tuần, khi nhân viên dọn nốt hội thoại tồn của tuần trước, tử số vượt mẫu
// số. Không có gì báo lỗi, chỉ là một con số vô lý.
//
// CÁCH CHỮA TẬN GỐC: lấy tử số từ cột tag `sđt` của `inbox_label_matrix`.
// Endpoint đó cũng lọc theo `conversations.created_at`
// (`inbox_label_matrix_builder.rb`), nên tử số là TẬP CON THẬT của mẫu số —
// tỷ lệ không bao giờ vượt 100% được nữa, kể cả về mặt số học.
// ============================================================================

// Ngưỡng coi là "đi ngang". Dưới mức này thì dao động thường chỉ là nhiễu của
// mẫu nhỏ, kêu lên "đang tụt" mỗi ngày thì người ta thôi không đọc nữa.
export const NGUONG_DI_NGANG = 2;

// Kỳ quá ngắn thì tỷ lệ nhảy loạn. Dưới mức này vẫn hiện số nhưng không phán
// quyết tăng/giảm.
export const NEN_TOI_THIEU = 10;

/**
 * Cửa sổ kỳ trước — PHẢI trùng đúng công thức của controller
 * (`reports_controller.rb#range`), nếu không con số "kỳ trước" của biểu đồ và
 * của ma trận tag đến từ hai khoảng thời gian khác nhau, tức phép so sánh giả.
 *
 * @param {number|string} tu - mốc đầu kỳ hiện tại (giây)
 * @param {number|string} den - mốc cuối kỳ hiện tại (giây)
 */
export function kyTruoc(tu, den) {
  const a = Number(tu);
  const b = Number(den);
  // Kiểm bằng "phải dương", KHÔNG bằng truthiness: `!a` loại luôn số 0 một
  // cách tình cờ. Ở đây 0 (tức 1970) đúng là đầu vào vô nghĩa nên vẫn loại,
  // nhưng loại CÓ Ý.
  if (!(a > 0) || !(b > 0) || b <= a) return null;
  return { tu: a - (b - a), den: a };
}

/**
 * Cộng một cột tag trên bảng chéo trang × tag.
 *
 * Trả `null` — KHÔNG phải 0 — khi không tìm thấy tag. Hai trường hợp đó khác
 * nhau hoàn toàn: "chưa hội thoại nào mang tag" và "tag đã bị đổi tên/xoá".
 * Trả 0 cho trường hợp thứ hai là bịa ra một con số, và trang sẽ bình thản hiện
 * 0% mãi mãi mà không ai biết vì sao.
 *
 * @param {{labels: Array, matrix: Array}} maTran
 * @param {string} tag - tên tag, lấy từ BAC_PHEU (đừng viết thẳng chuỗi)
 * @param {number|null} chiTrang - id hộp thư; bỏ trống = cộng mọi trang
 */
export function cotTag(maTran, tag, chiTrang = null) {
  const cot = (maTran?.labels || []).findIndex(l => l.title === tag);
  if (cot < 0) return null;
  const hang = maTran.matrix || [];
  if (chiTrang == null) {
    return hang.reduce((s, d) => s + (d?.[cot] ?? 0), 0);
  }
  const i = (maTran.inboxes || []).findIndex(t => t.id === chiTrang);
  return i < 0 ? 0 : (hang[i]?.[cot] ?? 0);
}

/**
 * Tổng số hội thoại của một trang (hoặc mọi trang) — mẫu số.
 * Lấy từ `summary` chứ không từ ma trận: ma trận chỉ đếm hội thoại CÓ TAG.
 */
export function tiLePhanTram(tu, mau) {
  if (!mau || tu === null || tu === undefined) return null;
  return Math.round((tu / mau) * 100);
}

/**
 * Phán quyết so với kỳ trước.
 *
 * Trả một trong: 'chua-chin' | 'khong-co-ky-truoc' | 'nen-mong'
 *              | 'tang' | 'giam' | 'di-ngang'
 *
 * `chua-chin` là luật quan trọng nhất và dễ bỏ sót nhất: bộ lọc gửi `den` =
 * cuối ngày hôm nay, còn controller tính kỳ trước = lùi đúng bằng độ dài kỳ.
 * Chọn "Hôm nay" tức là đem NỬA NGÀY ĐANG CHẠY so với TRỌN NGÀY HÔM QUA —
 * lệch có hệ thống theo hướng "đang tụt". Cả trang chỉ có ĐÚNG MỘT phép so
 * sánh nên không được để nó lệch.
 *
 * @param {number|null} nay - tỷ lệ kỳ này
 * @param {number|null} truoc - tỷ lệ kỳ trước
 * @param {object} boiCanh - { nenHienTai, kyChuaHomNay, soNgayKy }
 */
export function phanQuyet(nay, truoc, boiCanh = {}) {
  const { nenHienTai = 0, kyChuaHomNay = false, soNgayKy = 0 } = boiCanh;

  if (kyChuaHomNay && soNgayKy > 0 && soNgayKy <= 2) return 'chua-chin';
  if (nenHienTai < NEN_TOI_THIEU) return 'nen-mong';
  if (truoc === null || truoc === undefined) return 'khong-co-ky-truoc';
  if (nay === null || nay === undefined) return 'khong-co-ky-truoc';

  const lech = nay - truoc;
  if (Math.abs(lech) < NGUONG_DI_NGANG) return 'di-ngang';
  return lech > 0 ? 'tang' : 'giam';
}

/**
 * Số ngày của một kỳ, làm tròn lên — dùng cho luật `chua-chin`.
 */
export function soNgay(tu, den) {
  const a = Number(tu);
  const b = Number(den);
  if (!(a > 0) || !(b > 0) || b <= a) return 0;
  return Math.ceil((b - a) / 86400);
}

/**
 * Kỳ đang chọn có chứa thời điểm hiện tại không.
 * `bayGio` truyền vào được để test không phụ thuộc đồng hồ thật.
 */
export function chuaHomNay(tu, den, bayGio = Math.floor(Date.now() / 1000)) {
  const a = Number(tu);
  const b = Number(den);
  if (!(a > 0) || !(b > 0)) return false;
  return bayGio >= a && bayGio <= b;
}
